<template>
	<form class="mb-3">

		<div class="form-group c-login__form-group">
			<div class="input-group align-items-center mb-2">
				<div class="input-group-prepend mr-2 ml-3">
					<font-awesome-icon class="c-login__form-icon" :icon="['fal', 'user']"></font-awesome-icon>
				</div>
				<input type="text" class="form-control" name="email" id="email" placeholder="Email" autocomplete="off" v-model="email" v-validate="'required|email'">
			</div>
		</div>
		<div class="alert alert-warning alert-dismissible fade show mt-4 mb-4" role="alert" v-show="errors.has('email')">
			<strong>{{ errors.first('email') }}</strong>
		</div>

		<div class="form-group c-login__form-group">
			<div class="input-group align-items-center mb-2">
				<div class="input-group-prepend mr-2 ml-3">
					<font-awesome-icon class="c-login__form-icon" :icon="['fal', 'unlock-alt']"></font-awesome-icon>
				</div>
				<input type="password" class="form-control" name="password" id="password" placeholder="Password" autocomplete="off" v-validate="'required'" v-model="password">
			</div>
		</div>
		<div class="alert alert-warning alert-dismissible fade show mt-4 mb-4" role="alert" v-show="errors.has('password')">
			<strong>{{ errors.first('password') }}</strong>
		</div>

		<button class="c-login__button btn btn-block mt-5 pt-3 pb-3" @click.prevent="login()"> Se connecter </button>

	</form>
</template>

<script>
	import { auth } from '../../firebase'
	import { busNotifications } from '../../bus.js'


	export default {
		data() {
			return {
				email: '',
				password: '',
				dataUser: {},
			}
		},
		created() {
			auth.onAuthStateChanged( user => {
				if (user.email == 'admin@soleol.ch') {
					this.$router.push('/admin')
				} else {
					this.$router.push('/user')
				}
			})
		},
		methods: {
			login() {
				this.$validator.validate().then( res => {
					if( res ){
						auth.signInWithEmailAndPassword(this.email, this.password)
							.then( data => {
                if (this.email == 'admin@soleol.ch') {
                  this.$router.push('/admin')
                } else {
                  this.$router.push('/user')
                }
							})
							.catch( error => {
								busNotifications.makeNotification('danger', error.message)
							})
					}})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/login/Login.vue